var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartLineSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_430_7548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.49984 2.4221C2.49984 1.91507 2.0902 1.50543 1.58317 1.50543C1.07614 1.50543 0.666504 1.91507 0.666504 2.4221V12.0471C0.666504 13.3132 1.69202 14.3388 2.95817 14.3388H14.4165C14.9235 14.3388 15.3332 13.9291 15.3332 13.4221C15.3332 12.9151 14.9235 12.5054 14.4165 12.5054H2.95817C2.70609 12.5054 2.49984 12.2992 2.49984 12.0471V2.4221ZM14.1472 4.90283C14.5053 4.54475 14.5053 3.96324 14.1472 3.60517C13.7892 3.2471 13.2076 3.2471 12.8496 3.60517L9.83317 6.62444L8.1889 4.98017C7.83083 4.6221 7.24932 4.6221 6.89124 4.98017L3.68291 8.1885C3.32484 8.54658 3.32484 9.12809 3.68291 9.48616C4.04098 9.84423 4.62249 9.84423 4.98057 9.48616L7.5415 6.92809L9.18577 8.57236C9.54385 8.93043 10.1254 8.93043 10.4834 8.57236L14.1501 4.90569L14.1472 4.90283Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_430_7548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6667,
    height: 14.6667,
    fill: "currentColor",
    transform: "translate(0.666504 0.588745)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLineSolid);
export default __webpack_public_path__ + "static/media/chart-line-solid.663d8d6a39f9054dc1fdbb716c5bcc34.svg";
export { ForwardRef as ReactComponent };